import React from 'react';

import BaseIcon, { type BaseIconProps } from '../BaseIcon';

const PlayIcon: React.FC<BaseIconProps> = ({ ...rest }) => {
  return (
    <BaseIcon {...rest} viewBox="0 0 40 40" fill="none">
      <circle cx="20" cy="20" r="18" fill="white" fillOpacity="0.5" />

      <polygon points="15,12 28,20 15,28" fill="currentColor" />
    </BaseIcon>
  );
};

export default React.memo(PlayIcon);
